import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_TherapistCollaborationPrpContinuation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_TherapistCollaborationPrpContinuation' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><h3>Therapist Collaboration and PRP Continuation Form</h3></p>

<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Client's Name:</span></td>
        <td className='w-250'>
            <span className='eleHeader'>D.O.B</span></td>
        <td className='w-250'>
            <span className='eleHeader'>Date:</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='text' id='txtClientName' name='txtClientName' className='add-only' /></td>
        <td className='w-250'>
            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
        <td className='w-250'>
            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'>Dear Mental Health Provider:
    <input type='text' id='txtDearMentalHealthProvider' name='txtDearMentalHealthProvider' className='add-only w-300 custom-add-only' /> <br />
    Thank you for collaborating with R.I.S.E Family Services in providing quality mental health services to your client.
    RFS is seeking your recommendation to continue PRP services for your client. In our continued efforts to collaborate and
    coordinate for the clients we serve, please complete this form, sign and email to <a href="prpadmin@rise-family.org,">prpadmin@rise-family.org,</a>
</p>

<p className='e-750'>
    <span className='eleHeader'>1. Is this client benefiting from PRP services?</span>
    <input type='radio' id='rbIsThisClientBenefiting_Yes' name='rbIsThisClientBenefiting' className='add-only' value='Yes' /> Yes &nbsp;
    <input type='radio' id='rbIsThisClientBenefiting_No' name='rbIsThisClientBenefiting' className='add-only' value='No' /> No</p>

<p className='e-750'>
    <span className='eleHeader'>2. Do you recommend this client to continue PRP services at this time?</span>
    <input type='radio' id='rbDoYouRecommedThisClientTo_Yes' name='rbDoYouRecommedThisClientTo' className='add-only' value='Yes' /> Yes &nbsp;
    <input type='radio' id='rbDoYouRecommedThisClientTo_No' name='rbDoYouRecommedThisClientTo' className='add-only' value='No' /> No  <br />
    <b>If no, reason why?</b>
    <textarea id='txtDoYouReommendThis' name='txtDoYouReommendThis' className='add-only'></textarea></p>

<p className='w-750'><span className='eleHeader'>
    3. What evidence exists to show that the current therapeutic treatment for this client is insufficient to reduce the client's symptoms
    and functional behavioral impairments?</span>
    <textarea id='txtWhatEvidenceExistsToShowThat' name='txtWhatEvidenceExistsToShowThat' className='add-only'></textarea></p>

<p className='w-750'><span className='eleHeader'>
    4. Are there areas of concern where you would like us to focus more in relation to the client's goals? If so, please share:</span>
    <textarea id='txtAreThereAreasOfConcernWhere' name='txtAreThereAreasOfConcernWhere' className='add-only'></textarea></p>

<p className='w-750'><span className='eleHeader'>
    5. Primary DSM diagnosis:</span>
    <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /></p>

<p className='w-750'><span className='eleHeader'>
    6. Secondary DSM diagnosis:</span>
    <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /></p>

<p className='w-750'><span className='eleHeader'>7. Rehabilitation Activities Needed for this client:</span>
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_1' name='cbRehabilitationActivitiesNeeded_1' className='add-only' value='1'/> Age appropriate self-care skills (personal hygiene, grooming, nutrition, dietary planning, food preparation, self-administration of medication)
    <br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_2' name='cbRehabilitationActivitiesNeeded_2' className='add-only' value='2'/> Social skills (community integration activities, developing natural supports, developing linkages with and supporting the clients participation in community activities)<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_3' name='cbRehabilitationActivitiesNeeded_3' className='add-only' value='3'/> Independent living skills (maintenance of the living environment, community awareness, mobility skills, money management, accessing available entitlements)<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_4' name='cbRehabilitationActivitiesNeeded_4' className='add-only' value='4'/> Activities that support the minor's cultural interests ( sports, academic matriculation)<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_5' name='cbRehabilitationActivitiesNeeded_5' className='add-only' value='5'/> Conflict resolution<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_6' name='cbRehabilitationActivitiesNeeded_6' className='add-only' value='6'/> Anger management<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_7' name='cbRehabilitationActivitiesNeeded_7' className='add-only' value='7'/> Interactive skills with peers and authority figures<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_8' name='cbRehabilitationActivitiesNeeded_8' className='add-only' value='8'/> Maintaining personal living space<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_9' name='cbRehabilitationActivitiesNeeded_9' className='add-only' value='9'/> Maintaining age- appropriate boundaries<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_10' name='cbRehabilitationActivitiesNeeded_10' className='add-only' value='10'/> Maintaining personal safety in a social environment<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_11' name='cbRehabilitationActivitiesNeeded_11' className='add-only' value='11'/> Time management (including constructive use of structured and unstructured time)<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_12' name='cbRehabilitationActivitiesNeeded_12' className='add-only' value='12'/> Medication management<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_13' name='cbRehabilitationActivitiesNeeded_13' className='add-only' value='13'/> Obtaining/ retaining employment<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_14' name='cbRehabilitationActivitiesNeeded_14' className='add-only' value='14'/> Wellness self management & recovery; relapse prevention<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_15' name='cbRehabilitationActivitiesNeeded_15' className='add-only' value='15'/> Mobility and transportation skills<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_16' name='cbRehabilitationActivitiesNeeded_16' className='add-only' value='16'/> Housing Stability<br />
    <input type='checkbox' id='cbRehabilitationActivitiesNeeded_17' name='cbRehabilitationActivitiesNeeded_17' className='add-only' value='17'/> Wellness self management & recovery; relapse prevention<br />
</p>

<p className='w-750'><span className='eleHeader'>
    8. Additional comments:</span>
    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea></p>


<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Mental Health Provider Name:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>Mental Health Provider Agency (if applicable)</span></td>

    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtMentalHealthProviderName' name='txtMentalHealthProviderName' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtMentalHealthProviderAgency' name='txtMentalHealthProviderAgency' className='add-only' /></td>

    </tr>
    <tr>
        <td className='w-350'>
            <span className='eleHeader'>Mental Health Provider Signature with Credentials:</span></td>
        <td className='w-200'>
            <span className='eleHeader'>Mental Health Provider Email:</span></td>
        <td className='w-200'>
            <span className='eleHeader'>Mental Health Provider Phone:</span></td>

    </tr>
    <tr>
        <td className='w-350'>
            <input type='text' id='txtMentalHealthProviderSignature' name='txtMentalHealthProviderSignature' className='add-only' /></td>
        <td className='w-200'>
            <input type='text' id='txtMentalHealthProviderEmail' name='txtMentalHealthProviderEmail' className='add-only' /></td>
        <td className='w-200'>
            <input type='text' id='txtMentalHealthProviderPhone' name='txtMentalHealthProviderPhone' className='add-only' /></td>

    </tr>

    <tr>
        <td className='signature w-375'>&nbsp;</td>
        <td className='signature w-375'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-375'>PRP Rehabilitation Supervisor Name</td>
        <td className='small w-375'>PRP Rehabilitation Supervisor Signature:</td>
    </tr>


</table>



                
            </div>
        </form>
    )
}